import {create} from 'zustand';
import {ExternalOpenDateModalStore} from './types';

const useExternalOpenDateModalStore = create<ExternalOpenDateModalStore>(set => ({
	externalOpenDateModal: false,
	setExternalOpenDateModal: value => set({externalOpenDateModal: value}),
}));

export {useExternalOpenDateModalStore};
